document.addEventListener('cart:update_upsell', () => {
  async function renderQuickView () {
    try {
      const response = await fetch("?section_id=api-upsell-cart");
      const resText = await response.text();
      const html =  new DOMParser().parseFromString(resText, 'text/html');
      const sourceQty = html.querySelector('#cart-spot-upsell');
      document.querySelector("#cart-spot-upsell").replaceWith(sourceQty);
    } catch (error) {
      console.log(error);
    } 
  }
  renderQuickView()
});
